// extracted by mini-css-extract-plugin
module.exports = {"trigger":"WorkCodesEditor_trigger__3Dqn5","content":"WorkCodesEditor_content__zcTKV","help":"WorkCodesEditor_help__3_Df5","actions":"WorkCodesEditor_actions__1tG50"};